export default {
  props: {
    /**
      * Bearer token used for requests
      */
    token: {type: String, default: null}
  }
};
